import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Laboratory = () => {
  const [labOrders, setLabOrders] = useState([]);
  const [labSamples, setLabSamples] = useState([]);
  const [labTests, setLabTests] = useState([]);
  const [activeTab, setActiveTab] = useState('orders');

  useEffect(() => {
    if (activeTab === 'orders') fetchLabOrders();
    else if (activeTab === 'samples') fetchLabSamples();
    else if (activeTab === 'tests') fetchLabTests();
  }, [activeTab]);

  const fetchLabOrders = async () => {
    try {
      const response = await axios.get(`${window.location.protocol}//${window.location.hostname}/api/laboratory/orders`);
      setLabOrders(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchLabSamples = async () => {
    try {
      const response = await axios.get(`${window.location.protocol}//${window.location.hostname}/api/laboratory/samples`);
      setLabSamples(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchLabTests = async () => {
    try {
      const response = await axios.get(`${window.location.protocol}//${window.location.hostname}/api/laboratory/tests`);
      setLabTests(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <h2>Laboratory Management</h2>
      <div className="tabs">
        <button onClick={() => setActiveTab('orders')} className={activeTab === 'orders' ? 'active' : ''}>Lab Orders</button>
        <button onClick={() => setActiveTab('samples')} className={activeTab === 'samples' ? 'active' : ''}>Samples</button>
        <button onClick={() => setActiveTab('tests')} className={activeTab === 'tests' ? 'active' : ''}>Tests</button>
      </div>

      {activeTab === 'orders' && (
        <div>
          <h3>Laboratory Orders</h3>
          <ul>
            {labOrders.map(order => (
              <li key={order.id}>
                Order {order.id} - Patient {order.patientId} - {order.testType} - Status: {order.status}
              </li>
            ))}
          </ul>
        </div>
      )}

      {activeTab === 'samples' && (
        <div>
          <h3>Laboratory Samples</h3>
          <ul>
            {labSamples.map(sample => (
              <li key={sample.id}>
                Sample {sample.id} - Order {sample.labOrderId} - {sample.sampleType} - Status: {sample.status}
              </li>
            ))}
          </ul>
        </div>
      )}

      {activeTab === 'tests' && (
        <div>
          <h3>Laboratory Tests</h3>
          <ul>
            {labTests.map(test => (
              <li key={test.id}>
                Test {test.id} - Order {test.labOrderId} - {test.testName} - Result: {test.result} - Status: {test.status}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Laboratory;